import Vue from "vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "./styles/style.less";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Images from "./assets/images.js";
import * as CA from "@/utils/index";
import storage from '@/utils/locaStorage';
Vue.use(storage);

Vue.prototype.$CA = CA

Vue.use(ElementUI);

Vue.directive("title", {
  inserted: function(el, binding) {
    document.title = el.dataset.title;
  },
});

Vue.directive("icon", {
  inserted: function(el, binding) {
    // console.log('111111111',el.dataset, binding);
    let link = document.querySelector("link[rel*='icon']") || document.createElement("link");
    link.type = "image/x-icon";
    link.rel = "shortcut icon";
    link.href = el.dataset.icon;
    document.getElementsByTagName("head")[0].appendChild(link);
  },
});

Vue.prototype.$images = Images;

Vue.config.productionTip = false;
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
